import { useState } from 'react';

interface FAQItem {
  id: string;
  question: string;
  answer: string;
}

interface FAQAccordionProps {
  items: FAQItem[];
}

export default function FAQAccordion({ items }: FAQAccordionProps) {
  const [openId, setOpenId] = useState<string | null>(null);

  const toggle = (id: string) => {
    setOpenId(openId === id ? null : id);
  };

  return (
    <div className="space-y-3">
      {items.map((item) => {
        const isOpen = openId === item.id;
        return (
          <div
            key={item.id}
            className="bg-background-50 rounded-lg border border-background-200/70 overflow-hidden"
          >
            <button
              className="w-full flex items-center justify-between p-4 md:p-5 text-left cursor-pointer hover:bg-background-100/50 transition-colors duration-200"
              onClick={() => toggle(item.id)}
              aria-expanded={isOpen}
            >
              <h4 className="text-sm md:text-base font-medium text-foreground-900 pr-4 font-heading">
                {item.question}
              </h4>
              <div className={`w-6 h-6 flex items-center justify-center shrink-0 rounded-full transition-all duration-300 ${
                isOpen ? 'bg-primary-500 text-white rotate-180' : 'bg-background-200 text-foreground-600'
              }`}>
                <i className="ri-arrow-down-s-line text-sm"></i>
              </div>
            </button>
            <div
              className={`transition-all duration-300 overflow-hidden ${
                isOpen ? 'max-h-96 pb-4 md:pb-5 px-4 md:px-5' : 'max-h-0'
              }`}
            >
              <p className="text-sm text-foreground-600 leading-relaxed">
                {item.answer}
              </p>
            </div>
          </div>
        );
      })}
    </div>
  );
}